import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURJackpotsModel from "../models/BURJackpotsModel";

export class BURHasJackpotsProgressCondition implements ICondition {
    public check(): boolean {
        return BURJackpotsModel.jackpot_fragments.length > 0;
    }
}
